import React from 'react'
import PropTypes from 'prop-types'
import { withContext, lifecycle, compose } from 'recompose'
import throttle from 'lodash/throttle'

let callbacks = []

function registerForScroll(callback) {
  callbacks.push(callback)
}

function unregisterForScroll(callback) {
  const index = callbacks.indexOf(callback)
  if (index !== -1) callbacks = callbacks.slice(index, 1)
}

function emit(e) {
  callbacks.forEach(cb => cb(e))
}

export const ContentWrapper = props => (
  <div className='content-wrapper'>{props.children}</div>
)

const monitorScrollOnMount = lifecycle({
  checkWindowScroll(e) {
    const maxScroll = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    )
    const innerHeight = window.innerHeight
    const diff = maxScroll - innerHeight
    if (window.scrollY >= diff - 30) {
      emit()
    }
  },
  componentDidMount() {
    this.scrollHandler = throttle(this.checkWindowScroll, 100)
    this.resizeHandler = throttle(this.checkWindowScroll, 100)
    window && window.addEventListener('scroll', this.scrollHandler)
    window && window.addEventListener('resize', this.resizeHandler)
  },
  componentWillUnmount() {
    window && window.removeEventListener('scroll', this.scrollHandler)
    window && window.removeEventListener('resize', this.resizeHandler)
  }
})

const withScrollContext = withContext(
  {
    registerForScroll: PropTypes.func.isRequired,
    unregisterForScroll: PropTypes.func.isRequired
  },
  props => ({
    registerForScroll,
    unregisterForScroll
  })
)

const decorate = compose(withScrollContext, monitorScrollOnMount)

export default decorate(ContentWrapper)



// WEBPACK FOOTER //
// ./src/ui/shared/content-wrapper.js